if (!customElements.get('announcement-sale')) {
  customElements.define('announcement-sale', class extends HTMLElement {
    connectedCallback() {
      var root = this;
      // Unix seconds, resolved in Liquid in the store time zone
      var endsAt = (parseInt(root.getAttribute('data-end'), 10) || 0) * 1000;
      var expiry = root.getAttribute('data-expiry') || 'simple';
      var weekly = root.getAttribute('data-mode') !== 'date';

      // Weekly mode (same as smooche.com): the coming Monday 00:00 in the
      // visitor's time zone, rolling over to the next week when it is reached.
      function nextMonday() {
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate() + ((8 - now.getDay()) % 7 || 7), 0, 0, 0, 0).getTime();
      }
      var countdown = root.querySelector('[data-countdown]');
      var simple = document.querySelector('[data-ab-simple]');

      var els = countdown && {
        d: countdown.querySelector('[data-days]'),
        h: countdown.querySelector('[data-hours]'),
        m: countdown.querySelector('[data-mins]'),
        s: countdown.querySelector('[data-secs]')
      };

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function finish() {
        clearInterval(root.timer);
        if (expiry === 'simple') {
          root.hidden = true;
          if (simple) simple.hidden = false;
        } else if (expiry === 'hide_timer' && countdown) {
          countdown.hidden = true;
        }
      }

      function tick() {
        if (weekly) endsAt = nextMonday();
        var ms = Math.max(0, endsAt - Date.now());
        if (els) {
          var t = Math.floor(ms / 1000);
          els.d.textContent = pad(Math.floor(t / 86400));
          els.h.textContent = pad(Math.floor((t % 86400) / 3600));
          els.m.textContent = pad(Math.floor((t % 3600) / 60));
          els.s.textContent = pad(t % 60);
        }
        if (ms === 0 && !weekly) finish();
      }

      if (weekly) endsAt = nextMonday();
      if (!endsAt) {
        // End date could not be parsed: don't show a broken timer
        if (countdown) countdown.hidden = true;
        return;
      }

      tick();
      if (weekly || endsAt > Date.now()) this.timer = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  });
}
